'use client';

import React from 'react';
import NextImage, { ImageProps as NextImageProps } from 'next/image';
import { cloudinaryLoader } from 'utils/imageUtils';

export default function Image({ ...props }: NextImageProps) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <NextImage loader={cloudinaryLoader} {...props} />;
}
